export const UserTypes = {
  USER_CHANGE: '@user/USER_CHANGE',
  UPDATE_INSTRUMENTS_REQUEST: '@user/UPDATE_INSTRUMENTS_REQUEST',
  UPDATE_INSTRUMENTS_SUCCESS: '@user/UPDATE_INSTRUMENTS_SUCCESS',
  UPDATE_INSTRUMENTS_FAILURE: '@user/UPDATE_INSTRUMENTS_FAILURE',
  UPDATE_ASSETS_REQUEST: '@user/UPDATE_ASSETS_REQUEST',
  UPDATE_ASSETS_SUCCESS: '@user/UPDATE_ASSETS_SUCCESS',
  UPDATE_ASSETS_FAILURE: '@user/UPDATE_ASSETS_FAILURE',
  COMPLETE_TOUR: '@user/COMPLETE_TOUR',
  LOAD_DEMO_DATA: '@user/LOAD_DEMO_DATA',
  CLEAR_DEMO_DATA: '@user/CLEAR_DEMO_DATA',
  UPDATE_TAGS_REQUEST: '@user/UPDATE_TAGS_REQUEST',
  UPDATE_TAGS_SUCCESS: '@user/UPDATE_TAGS_SUCCESS',
  UPDATE_TAGS_FAILURE: '@user/UPDATE_TAGS_FAILURE',
};

interface Instrument {
  name: string;
  shortName: string;
  isDefault: boolean;
}

interface Asset {
  name: string;
  isDefault: boolean;
}

interface UserConfig {
  tradeInWeekend: boolean;
  goalOfMonth: number;
  currency: string;
  stopWin: number;
  stopLoss: number;
  instruments: Instrument[];
  assets: Asset[];
  tags: string[];
}

export interface SubscriptionInfo {
  plan: 'free' | 'basic' | 'pro' | 'premium';
  status: string;
  currentPeriodStart?: string;
  currentPeriodEnd?: string;
  cancelAtPeriodEnd: boolean;
  tradeLimit: number;
  tradeCount?: number;
  source?: 'stripe' | 'kiwify';
}

export interface TrialInfo {
  active: boolean;
  endsAt?: string;
  daysRemaining: number;
  insightsLimit: number;
}

export interface User {
  userId: string;
  name: string;
  phone: string;
  email: string;
  config: UserConfig;
  isActive: boolean;
  isAdmin: boolean;
  hasCompletedTour: boolean;
  hasDemoData: boolean;
  createdAt: string;
  subscription?: SubscriptionInfo;
  trial?: TrialInfo;
}

export interface UserState {
  user: User;
}
